import { render, staticRenderFns } from "./ArrowLeftIcon.vue?vue&type=template&id=d84ff10e&scoped=true&"
import script from "./ArrowLeftIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowLeftIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLeftIcon.vue?vue&type=style&index=0&id=d84ff10e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ff10e",
  null
  
)

export default component.exports